var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',{ref:"toastuiEditor",attrs:{"initialValue":_vm.editorText,"initialEditType":"wysiwyg","options":_vm.editorOptions,"height":_vm.heightEditor},on:{"load":_vm.onEditorLoad,"change":_vm.onEditorChange},model:{value:(_vm.editorText),callback:function ($$v) {_vm.editorText=$$v},expression:"editorText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }